module.exports = __webpack_public_path__ + "img/user-3.bfb32f54.jpg";